import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FiX } from "react-icons/fi";
import './klienciStyle/FormularzKlienta.css';

const API_URL = process.env.REACT_APP_API_URL;

function FormularzKlienta({ onKlientAdded }) {
    const [imie, setImie] = useState('');
    const [nazwisko, setNazwisko] = useState('');
    const [nrTelefonu, setNrTelefonu] = useState('');
    const [adresEmail, setAdresEmail] = useState('');
    const [status, setStatus] = useState('aktywny');
    const [rabat, setRabat] = useState(0);
    const [czyFirma, setCzyFirma] = useState(false);
    const [nip, setNip] = useState('');
    const [regon, setRegon] = useState('');
    const [nrKonta, setNrKonta] = useState('');
    const [notatkaKlient, setNotatkaKlient] = useState('');
    const [kontakt, setKontakt] = useState('');
    const [celKontaktu, setCelKontaktu] = useState('');
    const [rezygnacjaZPrzegladow, setRezygnacjaZPrzegladow] = useState(false);
    const [powodRezygnacji, setPowodRezygnacji] = useState('');
    const [grupaKliencka, setGrupaKliencka] = useState('');
    const [rodoPosprzedazowe, setRodoPosprzedazowe] = useState(false);
    const [rodoMarketingowe, setRodoMarketingowe] = useState(false);
    const [bledy, setBledy] = useState({});

    // Adres
    const [dodajAdres, setDodajAdres] = useState(false);
    const [kraj, setKraj] = useState('');
    const [miasto, setMiasto] = useState('');
    const [kodPocztowy, setKodPocztowy] = useState('');
    const [ulica, setUlica] = useState('');
    const [nrDomu, setNrDomu] = useState('');
    const [nrLokalu, setNrLokalu] = useState('');
    const [notatkaAdres, setNotatkaAdres] = useState('');
    const [bledyAdresu, setBledyAdresu] = useState({});

    // Urządzenia 
    const [dodajUrzadzenie, setDodajUrzadzenie] = useState(false);
    const [urzadzenia, setUrzadzenia] = useState([]);
    const [bledyUrzadzen, setBledyUrzadzen] = useState([]);
    const [deviceOptions, setDeviceOptions] = useState([]);

    //Pliki
    const [clientFiles, setClientFiles] = useState([]);
    //const [clientFile, setClientFile] = useState(null);
    const [clientFileName, setClientFileName] = useState("");
    const [statusMessage, setStatusMessage] = useState("");
    const [uploadStatus, setUploadStatus] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const fileInputRef = useRef(null);

    const [komunikat, setKomunikat] = useState('');

    //Urządzenia
    const addDeviceField = () => {
      setUrzadzenia([
        ...urzadzenia,
        {
          id_adres: null,
          nazwa: '',
          model: '',
          numer_seryjny: '',
          typ: '',
          rodzaj: '',
          gwarancja: '',
          uwagi: '',
          interwal_przegladow: 12,
          data_montazu: '',
          data_ostatniego_przegladu: ''
        }
      ]);
      setBledyUrzadzen([...bledyUrzadzen, {}]);
    };

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${API_URL}/lista-urzadzen`, { headers: { Authorization: `Bearer ${token}` } })
      .then(response => {
        setDeviceOptions(response.data);
      })
      .catch(error => console.error("Error fetching device options:", error));
  }, []);

  const getFilteredOptions = (device, field) => {
    const fieldsToFilter = ['typ', 'rodzaj', 'nazwa', 'model'];
    const filtered = deviceOptions.filter(option => {
      let match = true;
      fieldsToFilter.forEach(f => {
        if (f !== field && device[f]) {
          if (option[f] !== device[f]) match = false;
        }
      });
      return match;
    });
    // Zwracamy unikalne wartości dla danego pola
    return Array.from(new Set(filtered.map(option => option[field])));
  };

  const handleDeviceChange = (index, field, value) => {
    const newDevices = [...urzadzenia];
    newDevices[index][field] = value;
    // Aktualizujemy stan urządzeń
    setUrzadzenia(newDevices);
  
    // Jeśli zmieniono jedno z pól wyboru, sprawdź, czy można dopasować jedno urządzenie z listy
    if (['nazwa', 'model', 'typ', 'rodzaj'].includes(field)) {
      const currentDevice = newDevices[index];
      if (currentDevice.nazwa && currentDevice.model && currentDevice.typ && currentDevice.rodzaj) {
        const matchingDevices = deviceOptions.filter(option => 
          option.nazwa === currentDevice.nazwa &&
          option.model === currentDevice.model &&
          option.typ === currentDevice.typ &&
          option.rodzaj === currentDevice.rodzaj
        );
        if (matchingDevices.length === 1) {
          const matched = matchingDevices[0];
          // Jeśli domyślne wartości różnią się od aktualnych, uzupełniamy je
          if (currentDevice.interwal_przegladow !== matched.interwal_przegladow ||
              currentDevice.gwarancja !== matched.gwarancja) {
            newDevices[index]['interwal_przegladow'] = matched.interwal_przegladow;
            newDevices[index]['gwarancja'] = matched.gwarancja;
            setUrzadzenia([...newDevices]);
          }
        }
      }
    }
  };

  const walidujUrzadzenia = () => {
    let isValid = true;
    let tempBledy = urzadzenia.map((device) => {
      let errors = {};
      if (!device.nazwa) errors.nazwa = 'Nazwa jest wymagana';
      if (!device.model) errors.model = 'Model jest wymagany';
      if (!device.numer_seryjny) errors.numer_seryjny = 'Numer seryjny jest wymagany';
      if (!device.typ) errors.typ = 'Typ jest wymagany';
      if (!device.rodzaj) errors.rodzaj = 'Rodzaj jest wymagany';
      if (Object.keys(errors).length > 0) isValid = false;
      return errors;
    });
    setBledyUrzadzen(tempBledy);
    return isValid;
  };

  // Adres
  const walidujAdres = () => {
      let tempBledy = {};
      if (!kraj) tempBledy.kraj = 'Kraj jest wymagany';
      if (!miasto) tempBledy.miasto = 'Miasto jest wymagane';
      if (!kodPocztowy) tempBledy.kodPocztowy = 'Kod pocztowy jest wymagany';
      else if (!kodPocztowy.match(/^\d{2}-\d{3}$/))
        tempBledy.kodPocztowy = 'Nieprawidłowy format kodu pocztowego (np. 12-345)';
      if (!ulica) tempBledy.ulica = 'Ulica jest wymagana';
      if (!nrDomu) tempBledy.nrDomu = 'Numer domu jest wymagana';
  
      setBledyAdresu(tempBledy);
      return Object.keys(tempBledy).length === 0;
    };

    //Klient
    const walidujKlienta = () => {
        let tempBledy = {};
        if (!imie) tempBledy.imie = 'Imię jest wymagane';
        if (!nazwisko) tempBledy.nazwisko = 'Nazwisko jest wymagane';
        if (!nrTelefonu) {
          tempBledy.nrTelefonu = 'Numer telefonu jest wymagany';
        } else if (!nrTelefonu.match('^[0-9]{9,15}$')) {
          tempBledy.nrTelefonu = 'Nieprawidłowy numer telefonu';
        }
        if (adresEmail && !adresEmail.match('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$')) {
          tempBledy.adresEmail = 'Nieprawidłowy adres email';
        }
        if (!grupaKliencka) tempBledy.grupaKliencka = 'Grupa kliencka jest wymagana';
        if (nip && !nip.match('^[0-9]{10,12}$')) {
          tempBledy.nip = 'Nieprawidłowy NIP';
        }
        if (regon && !regon.match('^[0-9]{9,14}$')) {
          tempBledy.regon = 'Nieprawidłowy REGON';
        }
    
        setBledy(tempBledy);
        return Object.keys(tempBledy).length === 0;
      };

    


    //Pliki
    const handleChooseFilesClick = () => {
      fileInputRef.current.click();
    };


    const handleClientFilesChange = (e) => {
      if (!e.target.files) return;
      // Scal nowe pliki z już wybranymi, unikając duplikatów wg nazwy+rozmiaru
      const newFiles = Array.from(e.target.files).filter(f =>
        !clientFiles.some(existing => existing.name === f.name && existing.size === f.size)
      );
      setClientFiles(prev => [...prev, ...newFiles]);
    };

    const handleRemoveFile = (index) => {
      setClientFiles(prev => prev.filter((_, i) => i !== index));
    };



    const handleFileUpload = async (clientFiles, token, klientId) => {
      if (!clientFiles || clientFiles.length === 0) return;
    
      const uploadPromises = clientFiles.map(file => {
        const formData = new FormData();
        formData.append("plik", file);
        // nazwa_pliku – opcjonalnie możesz użyć file.name lub dodać inny input
        formData.append("nazwa_pliku", file.name);
        formData.append("idPowiazania", klientId);
    
        return axios.post(
          `${API_URL}/pliki/upload/klient`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`
            }
          }
        );
      });
    
      // Poczekaj aż wszystkie pliki się przeslą
      await Promise.all(uploadPromises);
    };

    //Podsumowanie
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitting) return;
        setSubmitting(true);
        
        const klientValid = walidujKlienta();
        const adresValid = dodajAdres ? walidujAdres() : true;
        const urzadzeniaValid = dodajUrzadzenie ? walidujUrzadzenia() : true;
      
        if (klientValid && adresValid && urzadzeniaValid) {
          try {
            const token = localStorage.getItem('token');
      
            // 1. Dodaj klienta
            const klientResponse = await axios.post(
              `${API_URL}/klienci`,
              {
                imie,
                nazwisko,
                nr_telefonu: nrTelefonu,
                adres_email: adresEmail,
                status,
                rabat,
                czy_firma: czyFirma,
                nip,
                regon,
                nr_konta: nrKonta,
                notatka: notatkaKlient,
                kontakt,
                cel_kontaktu: celKontaktu,
                rezygnacja_z_przegladow: rezygnacjaZPrzegladow,
                powod_rezygnacji: powodRezygnacji,
                grupa_kliencka: grupaKliencka,
                rodo_posprzedazowe: rodoPosprzedazowe,
                rodo_marketingowe: rodoMarketingowe,
              },
              { headers: { Authorization: `Bearer ${token}` } }
            );
            const klient = klientResponse.data;
      
            // 2. Jeśli zaznaczono dodanie adresu, dodaj adres klienta
            let adres = null;
            if (dodajAdres) {
              const adresResponse = await axios.post(
                `${API_URL}/adresy`,
                {
                  kraj,
                  miasto,
                  kod_pocztowy: kodPocztowy,
                  ulica,
                  nr_domu: nrDomu,
                  nr_lokalu: nrLokalu,
                  notatka: notatkaAdres,
                  id_klient: klient.id_klient
                },
                { headers: { Authorization: `Bearer ${token}` } }
              );
              adres = adresResponse.data;
            }

            //await handleFileUpload(clientFiles, token, klient.id_klient);
      
      
            // 3. Jeśli zaznaczono dodanie urządzeń oraz dodano adres, dodaj urządzenia
            if (dodajUrzadzenie && adres) {
              const devicesToCreate = urzadzenia.map(device => ({
                ...device,
                id_adres: adres.id_adres,
                data_ostatniego_przegladu: device.data_montazu
              }));
      
              await Promise.all(
                devicesToCreate.map(device =>
                  axios.post(`${API_URL}/urzadzenia`, device, {
                    headers: { Authorization: `Bearer ${token}` }
                  })
                )
              );
            }
    
            onKlientAdded(klient);
            if (clientFiles.length) {
              const token = localStorage.getItem("token");
              await Promise.all(clientFiles.map(file => {
                const formData = new FormData();
                formData.append("plik", file);
                formData.append("nazwa_pliku", file.name);
                formData.append("idPowiazania", klient.id_klient);
                return axios.post(
                  `${API_URL}/pliki/upload/klient`,
                  formData,
                  { headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` }}
                );
              }));
            }

            setKomunikat('Klient został dodany.');
            // Reset formularza (opcjonalnie)
            setImie('');
            setNazwisko('');
            setNrTelefonu('');
            setAdresEmail('');
            setStatus('aktywny');
            setRabat(0);
            setCzyFirma(false);
            setNip('');
            setRegon('');
            setNrKonta('');
            setNotatkaKlient('');
            setKontakt('');
            setCelKontaktu('');
            setRezygnacjaZPrzegladow(false);
            setPowodRezygnacji('');
            setBledy({});
            setDodajAdres(false);
            setKraj('');
            setMiasto('');
            setKodPocztowy('');
            setUlica('');
            setNrDomu('');
            setNrLokalu('');
            setNotatkaAdres('');
            setBledyAdresu({});
            setDodajUrzadzenie(false);
            setUrzadzenia([]);
            setGrupaKliencka('');
            setRodoPosprzedazowe(false);
            setRodoMarketingowe(false);
          } catch (error) {
            console.error('Błąd dodawania klienta:', error);
            setKomunikat(`Błąd: ${error.response?.data?.error || error.message}`);
          } finally {
            setSubmitting(false);
          }
        } else {
          setSubmitting(false);
        }
      };

    

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <div>
              <h3>Dane Klienta</h3>
          </div>
          <div className='add-client-wrapper'>
            <div className='add-client-column'>
              <div>
                <label>Imię*:</label>
                <input type="text" value={imie} onChange={(e) => setImie(e.target.value)} />
                {bledy.imie && <p style={{ color: 'red' }}>{bledy.imie}</p>}
              </div>
              <div>
                <label>Nazwisko*:</label>
                <input type="text" value={nazwisko} onChange={(e) => setNazwisko(e.target.value)} />
                {bledy.nazwisko && <p style={{ color: 'red' }}>{bledy.nazwisko}</p>}
              </div>
              <div>
                <label>Nr telefonu*:</label>
                <input type="tel" value={nrTelefonu} onChange={(e) => setNrTelefonu(e.target.value)} />
                {bledy.nrTelefonu && <p style={{ color: 'red' }}>{bledy.nrTelefonu}</p>}
              </div>
              <div>
                <label>Adres email:</label>
                <input type="email" value={adresEmail} onChange={(e) => setAdresEmail(e.target.value)} />
                {bledy.adresEmail && <p style={{ color: 'red' }}>{bledy.adresEmail}</p>}
              </div>
              <div>
                <label>Status*:</label>
                <select value={status} onChange={(e) => setStatus(e.target.value)} className='add-client-select'>
                    <option value="aktywny">Aktywny</option>
                    <option value="nieaktywny">Nieaktywny</option>
                    <option value="zablokowany">Zablokowany</option>
                    <option value="zalega z płatnościami">Zalega z płatnościami</option>
                </select>
              </div>
              <div>
                <label>Rabat:</label>
                <input type="number" value={rabat} onChange={(e) => setRabat(parseInt(e.target.value))} />
              </div>

              <div>
                <label>Grupa kliencka*:</label>
                <input
                  type="text"
                  value={grupaKliencka}
                  maxLength={50}
                  onChange={e => setGrupaKliencka(e.target.value)}
                />
                {bledy.grupaKliencka && <p style={{ color: 'red' }}>{bledy.grupaKliencka}</p>}
              </div>
            </div>
          
{/* ----------------------------------------------*/}
            <div className='add-client-column'>
              {/* RODO */}
              <div>
                <label className='add-client-label'>
                  Zgoda RODO po-sprzedażowe
                  <input
                    type="checkbox"
                    className='add-client-input'
                    checked={rodoPosprzedazowe}
                    onChange={e => setRodoPosprzedazowe(e.target.checked)}
                  />
                </label>
                </div>
                <div>
                  <label className='add-client-label'>
                    <span>Zgoda RODO marketingowe</span>
                    <input
                      type="checkbox"
                      className='add-client-input'
                      checked={rodoMarketingowe}
                      onChange={e => setRodoMarketingowe(e.target.checked)}
                    />
                  </label>
                </div>

                <div>
                  <label className='add-client-label'>
                    Czy firma:
                    <input 
                      type="checkbox" 
                      className='add-client-input'
                      checked={czyFirma} 
                      onChange={(e) => setCzyFirma(e.target.checked)} />
                  </label>
                </div>
                {czyFirma && (
                  <>
                    <div>
                      <label>NIP:</label>
                      <input type="text" value={nip} onChange={(e) => setNip(e.target.value)} />
                      {bledy.nip && <p style={{ color: 'red' }}>{bledy.nip}</p>}
                    </div>
                    <div>
                      <label>REGON:</label>
                      <input type="text" value={regon} onChange={(e) => setRegon(e.target.value)} />
                      {bledy.regon && <p style={{ color: 'red' }}>{bledy.regon}</p>}
                    </div>
                    <div>
                      <label>Nr konta:</label>
                      <input type="text" value={nrKonta} onChange={(e) => setNrKonta(e.target.value)} />
                    </div>
                  </>
                )}

                <div>
                  <label>Termin najbliższego kontaktu do klienta</label>
                  <input type='date' value={kontakt} onChange={(e) => setKontakt(e.target.value)} className='add-client-select'/>
                </div>

                <div>
                  <label>Cel kontaktu do klienta</label>
                  <input type='textarea' value={celKontaktu} onChange={(e) => setCelKontaktu(e.target.value)} className='add-client-select'/>
                </div>

                <div>
                  <label className='add-client-label'>Rezygnacja z przeglądów
                    <input type='checkbox' checked={rezygnacjaZPrzegladow} onChange={(e) => setRezygnacjaZPrzegladow(e.target.checked)}  className='add-client-input'/>
                  </label>
                </div>
                {rezygnacjaZPrzegladow && (
                  <div>
                    <label >Powód rezygnacji
                      <textarea value={powodRezygnacji} onChange={(e) => setPowodRezygnacji(e.target.value)} />
                    </label>
                  </div>
                )}

                <div>
                  <label>Notatka klienta:</label>
                  <textarea value={notatkaKlient} onChange={(e) => setNotatkaKlient(e.target.value)} />
                </div>
              </div>
          </div>


            <div>
        <h3>Dołącz pliki (max 10 MB każdy):</h3>
        {/* Ukryty input */}
        <input
          type="file"
          multiple
          accept=".pdf,.jpeg,.jpg,.png,.tiff,.docx,.xlsx"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleClientFilesChange}
        />

        {/* Przycisk otwierający wybór plików */}
        <button type="button" onClick={handleChooseFilesClick}>
          Wybierz pliki
        </button>

        {/* Lista wybranych plików */}
        {clientFiles.length > 0 && (
          <ul style={{ listStyle: "none", padding: 0 }}>
            {clientFiles.map((file, idx) => (
              <li key={idx} style={{ display: "flex", alignItems: "center", marginTop: 4 }}>
                <span style={{ flexGrow: 1 }}>
                  {file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)
                </span>
                <button
                  type="button"
                  onClick={() => handleRemoveFile(idx)}
                  style={{
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    color: "red",
                    fontSize: "1.2em"
                  }}
                  aria-label="Usuń plik"
                >
                  <FiX />
                </button>
              </li>
            ))}
          </ul>
        )}

        {/* Jeśli chcesz dodać jeszcze pliki */}
        {clientFiles.length > 0 && (
          <button type="button" onClick={handleChooseFilesClick} style={{ marginTop: 8 }}>
            Dodaj kolejny
          </button>
        )}
      </div>

                <div className='add-client-address'>
                  <label className='add-client-label'>
                    Dodaj adres:
                    <input type="checkbox" checked={dodajAdres} className='add-client-input' onChange={(e) => {
                      setDodajAdres(e.target.checked);
                      // Jeśli nie dodajemy adresu, upewnij się, że nie można dodawać urządzeń
                      if (!e.target.checked) setDodajUrzadzenie(false);
                    }} />
                  </label>
                </div>
        {dodajAdres && (
          <>
            <div>
                <h3>Adres</h3>
            </div>
            <div>
            <label>Kraj*:</label>
                <input type="text" value={kraj} onChange={(e) => setKraj(e.target.value)} />
                {bledyAdresu.kraj && <p style={{ color: 'red' }}>{bledyAdresu.kraj}</p>}
            </div>
            <div>
                <label>Miasto*:</label>
                <input type="text" value={miasto} onChange={(e) => setMiasto(e.target.value)} />
            {bledyAdresu.miasto && <p style={{ color: 'red' }}>{bledyAdresu.miasto}</p>}
            </div>
            <div>
                <label>Kod pocztowy*:</label>
                <input type="text" value={kodPocztowy} onChange={(e) => setKodPocztowy(e.target.value)} />
            {bledyAdresu.kodPocztowy && <p style={{ color: 'red' }}>{bledyAdresu.kodPocztowy}</p>}
            </div>
            <div>
                <label>Ulica*:</label>
                <input type="text" value={ulica} onChange={(e) => setUlica(e.target.value)} />
            {bledyAdresu.ulica && <p style={{ color: 'red' }}>{bledyAdresu.ulica}</p>}
            </div>
            <div>
            <label>Nr domu:</label>
                <input type="text" value={nrDomu} onChange={(e) => setNrDomu(e.target.value)} />
                {bledyAdresu.nrDomu && <p style={{ color: 'red' }}>{bledyAdresu.nrDomu}</p>}
            </div>
            <div>
                <label>Nr lokalu:</label>
                <input type="text" value={nrLokalu} onChange={(e) => setNrLokalu(e.target.value)} />
            {bledyAdresu.nrLokalu && <p style={{ color: 'red' }}>{bledyAdresu.nrLokalu}</p>}
            </div>

            <div>
              <label>Notatka adres:</label>
              <input type="text" value={notatkaAdres} onChange={(e) => setNotatkaAdres(e.target.value)} />
            </div>
            <div>
              <label>
                Dodaj urządzenia:
                <input
                  type="checkbox"
                  checked={dodajUrzadzenie}
                  onChange={(e) => setDodajUrzadzenie(e.target.checked)}
                />
              </label>
            </div>
          </>
        )}
        {dodajUrzadzenie && (
          <div>
            <h3>Urządzenia</h3>
            {urzadzenia.map((device, index) => (
              <div key={index} style={{ border: '1px solid #ccc', padding: '8px', marginBottom: '8px' }}>
                <div>
                  <label>Nazwa*:</label>
                  <select
                    value={device.nazwa}
                    onChange={(e) => handleDeviceChange(index, 'nazwa', e.target.value)}
                    required
                  >
                    <option value="">-- Wybierz nazwę --</option>
                    {getFilteredOptions(device, 'nazwa').map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                  {bledyUrzadzen[index]?.nazwa && <p style={{ color: 'red' }}>{bledyUrzadzen[index].nazwa}</p>}
                </div>
                <div>
                  <label>Model*:</label>
                  <select
                    value={device.model}
                    onChange={(e) => handleDeviceChange(index, 'model', e.target.value)}
                    required
                  >
                    <option value="">-- Wybierz model --</option>
                    {getFilteredOptions(device, 'model').map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                  {bledyUrzadzen[index]?.model && <p style={{ color: 'red' }}>{bledyUrzadzen[index].model}</p>}
                </div>
                <div>
                  <label>Numer seryjny*:</label>
                  <input
                    type="text"
                    value={device.numer_seryjny}
                    onChange={(e) => handleDeviceChange(index, 'numer_seryjny', e.target.value)}
                    required
                  />
                  {bledyUrzadzen[index]?.numer_seryjny && <p style={{ color: 'red' }}>{bledyUrzadzen[index].numer_seryjny}</p>}
                </div>
                <div>
                  <label>Typ*:</label>
                  <select
                    value={device.typ}
                    onChange={(e) => handleDeviceChange(index, 'typ', e.target.value)}
                    required
                  >
                    <option value="">-- Wybierz typ --</option>
                    {getFilteredOptions(device, 'typ').map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                  {bledyUrzadzen[index]?.typ && <p style={{ color: 'red' }}>{bledyUrzadzen[index].typ}</p>}
                </div>
                <div>
                  <label>Rodzaj*:</label>
                  <select
                    value={device.rodzaj}
                    onChange={(e) => handleDeviceChange(index, 'rodzaj', e.target.value)}
                    required
                  >
                    <option value="">-- Wybierz rodzaj --</option>
                    {getFilteredOptions(device, 'rodzaj').map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                  {bledyUrzadzen[index]?.rodzaj && <p style={{ color: 'red' }}>{bledyUrzadzen[index].rodzaj}</p>}
                </div>
                <div>
                  <label>Gwarancja (miesiące)*:</label>
                  <input
                    type="number"
                    value={device.gwarancja || ''}
                    onChange={(e) => handleDeviceChange(index, 'gwarancja', e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label>Data montażu*:</label>
                  <input
                    type="date"
                    value={device.data_montazu}
                    onChange={(e) => handleDeviceChange(index, 'data_montazu', e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label>Interwal przeglądów:</label>
                  <input
                    type="number"
                    value={device.interwal_przegladow}
                    onChange={(e) => handleDeviceChange(index, 'interwal_przegladow', e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label>Uwagi:</label>
                  <textarea
                    value={device.uwagi}
                    onChange={(e) => handleDeviceChange(index, 'uwagi', e.target.value)}
                  ></textarea>
                </div>
              </div>
            ))}
            <button type="button" onClick={addDeviceField}>Dodaj kolejne urządzenie</button>
          </div>
        )}

        <button type="submit" disabled={submitting}>
            {submitting ? 'Przetwarzanie...' : 'Dodaj klienta'}
        </button>
      </form>
      {komunikat && <p>{komunikat}</p>}
      {uploadStatus && <p>{uploadStatus}</p>}
    </div>
  );
}

export default FormularzKlienta;